// extracted by mini-css-extract-plugin
export default {"container":"style_container__nvKCJ","left":"style_left__WYkYQ","middle":"style_middle__6KLYk","right":"style_right__hQ0KZ","recording-blink":"style_recording-blink__RYXBA"};